import EventEmitter from "eventemitter3";

class FileEvents extends EventEmitter {}

export default new FileEvents();
